import { createContext, useContext } from 'react';

import {
  DEFAULT_TOOTH_SLICE_OPTIONS_BY_SERIES,
  TOOTH_SLICE_THICKNESS_OPTIONS_MM,
  type FullHeadMprSlicesContextValue,
} from '../config';

const disabledFullHeadMprSlices: FullHeadMprSlicesContextValue = {
  canChangeOptions: false,
  tiles: [],
  branch: 'server',
  isClearingSelection: false,
  isSelectionReady: true,
  fullHeadMprSliceGroups: [],
  loading: 'idle',
  pendingTileIDs: [],
  recordsByTileID: {},
  selectedTiles: [],
  sliceOptions: DEFAULT_TOOTH_SLICE_OPTIONS_BY_SERIES,
  thicknessOptionsMm: TOOTH_SLICE_THICKNESS_OPTIONS_MM,
  toothInput: null,
  zoomedTile: null,
  zoomedTileID: '',
  clearSelection: () => {},
  isTileSelected: () => false,
  resolveViewSelection: () => null,
  setSeriesOptions: () => {},
  setZoomedTileID: () => {},
  toggleTile: () => {},
};

export const FullHeadMprSlicesContext =
  createContext<FullHeadMprSlicesContextValue>(disabledFullHeadMprSlices);

export const useFullHeadMprSlicesContext = () =>
  useContext(FullHeadMprSlicesContext);
